import { Component, OnInit, ViewChild } from '@angular/core'
import { AuthService } from '@data/services/modules/auth/auth.service'

import { WorklogBacklogComponent } from '../components/worklog-backlog/worklog-backlog.component'
import { WorklogBoardComponent } from '../components/worklog-board/worklog-board.component'
import { WorklogTimelineComponent } from '../components/worklog-timeline/worklog-timeline.component'
import { EpicWithStatus } from '../data/interfaces/epic.interface'

/**
 * Contenedor del Mapa de trabajo (reemplaza el mapa de metro). Alterna entre la vista
 * Lista (Backlog) y el Tablero (sprint activo), y orquesta los diálogos compartidos de
 * alta y de detalle. Gated por `roadmap.view`; alta abierta a internos; mover = isDev.
 */
@Component({
  selector: 'app-worklog-container',
  templateUrl: './worklog-container.component.html',
  styleUrls: ['./worklog-container.component.scss'],
})
export class WorklogContainerComponent implements OnInit {
  //* Arranca en el Backlog: es la vista que le sirve a todos. Quien reporta encuentra ahí lo suyo
  //* con el filtro «Solo las mías» —que sustituyó a la pestaña homónima— y el equipo pasa al
  //* Tablero en un clic.
  view: 'backlog' | 'board' | 'times' | 'history' = 'backlog'

  createVisible = false
  detailVisible = false
  detailId: string | null = null

  epicVisible = false
  epicRow: EpicWithStatus | null = null

  isDev = false

  @ViewChild(WorklogBacklogComponent) backlog?: WorklogBacklogComponent
  @ViewChild(WorklogBoardComponent) boardCmp?: WorklogBoardComponent
  @ViewChild(WorklogTimelineComponent) timelineCmp?: WorklogTimelineComponent

  constructor(private auth: AuthService) {}

  ngOnInit(): void {
    this.isDev = !!this.auth.getUser?.user?.isDev
  }

  openDetail(id: string): void {
    this.detailId = id
    this.detailVisible = true
  }

  openEpicDetail(row: EpicWithStatus): void {
    this.epicRow = row
    this.epicVisible = true
  }

  onCreated(): void {
    this.reloadActive()
  }

  /**
   * El catálogo de épicas cambió (F-037): se renombró una o se retiró. La vista activa la vuelve a
   * pedir porque el Backlog agrupa por épica y el Gantt dibuja una fila por cada una — sin esto, el
   * nombre viejo sigue en pantalla hasta recargar, que es justo lo que la tarea pedía evitar.
   */
  onEpicChanged(): void {
    this.reloadActive()
  }

  onDetailChanged(): void {
    this.reloadActive()
  }

  private reloadActive(): void {
    // La vista activa está en el DOM (los componentes se montan/desmontan con *ngIf).
    setTimeout(() => {
      if (this.view === 'backlog') this.backlog?.reload()
      //! Tiempos tiene que estar aquí: es de donde se abre una épica sin trabajo —y la única vista
      //! que las lista— así que retirarla desde ahí y no recargar deja el chip en pantalla
      //! señalando algo que ya no existe. Antes caía al `else` y recargaba el Tablero, que ni
      //! siquiera está montado.
      else if (this.view === 'times') this.timelineCmp?.reload()
      else if (this.view === 'board') this.boardCmp?.reload()
    })
  }
}
